import { render, staticRenderFns } from "./PrivacyLazyLovers.vue?vue&type=template&id=41d38e0b&scoped=true"
import script from "./PrivacyLazyLovers.vue?vue&type=script&lang=js"
export * from "./PrivacyLazyLovers.vue?vue&type=script&lang=js"
import style0 from "./PrivacyLazyLovers.vue?vue&type=style&index=0&id=41d38e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d38e0b",
  null
  
)

export default component.exports